import { DataBean } from "../DataBean";

export class UpcomingMaintenance extends DataBean {

  public async getUpcomingMaintenanceCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getUpcomingMaintenanceCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getUpcomingMaintenanceRender( page: number, rows: number, properties: any, referenceDay: string): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getUpcomingMaintenanceRender_Number_Number_java.util.Map_String",
      [ page, rows, properties, referenceDay]
    );
  }

  public async deleteUpcomingMaintenance(idupcomingmaintenance: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deleteUpcomingMaintenance_Number",
      [idupcomingmaintenance]
    );
  }

  public async updateUpcomingMaintenanceData(Bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.DataBean_updateUpcomingMaintenanceData_java.util.Map",
      [Bean]
    );
  }


  public async updateUpcomingMaintenance(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.UpcomingMaintenance_updateUpcomingMaintenance_com.orange.finance.processcontract.bean.UpcomingMaintenance",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.UpcomingMaintenance",
        },
      ]
    );
  }
}
